import React, { useState, useEffect, useMemo } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject, GetListaSubTasaValores } from '../../../utils/helpers';
import { useEntidad } from '../../hooks/useEntidad';
import SubTasaValorModal from '../SubTasaValorModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { isNull } from '../../../utils/validator';
import { getDateToString } from '../../../utils/convert';


const SubTasaValoresGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idTasa: 0,
      idSubTasa: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const [rangoSolapado, setRangoSolapado] = useState(null);

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        idTasa: props.data.idTasa,
        idSubTasa: props.data.idSubTasa,
        list: list };
    });
  }
  useEffect(mount, [props.data]);

  const listaSubTasaValores = useMemo(() => {
    return GetListaSubTasaValores(false);
  })

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickSubTasaValorAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickSubTasaValorView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickSubTasaValorModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickSubTasaValorRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickSubTasaValoresDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>                                  
                              </div>

  const getDescCodigo = (key) => {
    const row = listaSubTasaValores.find(f => f.key === key);
    return (row) ? row.value : '';
  }

  const tableColumns = [
    { Header: 'Código', Cell: (props) => getDescCodigo(props.value), accessor: 'codigo', width: '25%' },
    { Header: 'Valor', accessor: 'valor', width: '25%' },
    { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '20%' },
    { Header: 'Hasta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaHasta', width: '20%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickSubTasaValorAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idTasa: state.idTasa,
        idSubTasa: state.idSubTasa,
        fechaDesde: null,
        fechaHasta: null,
        codigo: '',
        valor: '',
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickSubTasaValorView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickSubTasaValorModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickSubTasaValorRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleClickSubTasaValoresDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }  

  //funciones
  function RemoveSubTasaValor(row) {
    row.state = 'r';
    props.onChange('SubTasaValor', row);
  }

  function UpdateSubTasaValor(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('SubTasaValor', row);
  }

  function ValidateDatesConflicts(row) {
    const listOthers = state.list.filter(f => f.codigo === row.codigo && f.id !== row.id);
    const conflicts = listOthers.filter(f =>
      (f.fechaDesde <= row.fechaHasta || isNull(f.fechaDesde) || isNull(row.fechaHasta)) &&
      (f.fechaHasta >= row.fechaDesde || isNull(f.fechaHasta) || isNull(row.fechaDesde))
    );
    return (conflicts.length === 0);
  }

  return (
  <>

    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional de valores"
          processKey={props.processKey}
          entidad="SubTasaValor"
          idEntidad={state.dataTagger.idEntidad}
          disabled={props.disabled}
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveSubTasaValor(row);
            }}
        />
    }

    {state.showForm && 
        <SubTasaValorModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm
            }}
            rangoSolapado={rangoSolapado}
            onDismiss={() => {
              setRangoSolapado(null);
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              if (ValidateDatesConflicts(row)) {
                setRangoSolapado(null);
                setState(prevState => {
                    return {...prevState, showForm: false, rowForm: null};
                });
                UpdateSubTasaValor(row);
              }
              else {
                setRangoSolapado({codigo: row.codigo, fechaDesde: row.fechaDesde, fechaHasta: row.fechaHasta});
              }
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

SubTasaValoresGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

SubTasaValoresGrid.defaultProps = {
  disabled: false
};

export default SubTasaValoresGrid;